<ng-container *transloco="let t">
    <div [ngClass]="isMobile ? 'section' : ''">
        <div class="d-flex align-items-start info flex-column"
                [ngClass]="{
                'confirmed': registrationConfirmed,
                'pending': !registrationConfirmed,
                'is-owner': isOwner
                }"
        >

            <div class="d-flex justify-content-center align-items-center" [ngClass]="{'as-badge': !isOwner}">
                <img *ngIf="isOwner || !isMobile"
                     [src]="registrationConfirmed
                    ? 'assets/icons/icons-alt/warning-icon-green.svg'
                    : 'assets/icons/icons-alt/warning-icon-orange.svg'"
                     alt="Info"
                     class="card-body__icon pe-2"
                />
                <p class="bolded">
                    {{
                    t(registrationConfirmed
                        ? 'app.common.registrationStatus.1'
                        : isOwner
                            ? 'my.tracey.order.state.' + paymentStatus
                            : 'app.common.registrationStatus.2'
                    )| uppercase
                    }}
                </p>
            </div>


            <div class="w-100">
                <p class="fs-14 mt-1">
                    {{
                    registrationConfirmed
                        ? (isOwner
                            ? t('my.entry.registration.confirmed.description.owner')
                            : t('my.entry.registration.confirmed.description'))
                        : (isOwner
                            ? t('my.entry.payment.pending.description.owner')
                            : t('my.entry.payment.pending.description'))
                    }}
                </p>

                <ng-container *ngIf="!isOwner && owner && isMobile">
                    <div class="divider-horizontal mt-2"></div>
                    <p class="fs-14 mt-1">
                        {{ t('my.entry.payment.assigned.to') }}:
                        <strong>{{ owner.firstName ?? '' }} {{owner.lastName ?? ''}}</strong>
                    </p>
                </ng-container>
            </div>
        </div>
    </div>
</ng-container>
